// src/utils/eventBus.js
import mitt from 'mitt'

const emitter = mitt()

const emit = (event, payload) => {
  console.log(`📣 Emitting event: ${event}`, payload)
  emitter.emit(event, payload)
}

const on = (event, handler) => {
  emitter.on(event, handler)
}

// --- THIS IS THE FIX ---
const off = (event, handler) => {
  emitter.off(event, handler)
}
// --- END OF FIX ---

export const eventBus = {
  emit,
  on,
  off, // <-- EXPORT the corrected function
}
